import {
  AmabAfabMedicalPreference,
  type MedicalFlowDetail,
  MedicalQuestionsWorkflow
} from "#/components/carrot-plans/steps/medical-questions/medicalFlowConstants"
import { useFlags } from "launchdarkly-react-client-sdk"
import { useParams } from "react-router-dom"

const JourneyByUrlParam: { [key: string]: MedicalFlowDetail } = {
  "1": {
    journey: "PREGNANT",
    amabAfabPreference: AmabAfabMedicalPreference.PREF_UNAVAILABLE_FOR_JOURNEY,
    workflow: MedicalQuestionsWorkflow.PREGNANCY_MEDICAL_QUESTIONS
  },
  "2": {
    journey: "TRY_PREGNANT",
    amabAfabPreference: AmabAfabMedicalPreference.AFAB,
    workflow: MedicalQuestionsWorkflow.AFAB_MEDICAL_QUESTIONS
  },
  "3": {
    journey: "PRESERVATION",
    amabAfabPreference: AmabAfabMedicalPreference.AFAB,
    workflow: MedicalQuestionsWorkflow.AFAB_MEDICAL_QUESTIONS
  },
  "4": {
    journey: "ASSISTED_REPRODUCTION",
    amabAfabPreference: AmabAfabMedicalPreference.AFAB,
    workflow: MedicalQuestionsWorkflow.AFAB_MEDICAL_QUESTIONS
  },
  "5": {
    journey: "MENOPAUSE",
    amabAfabPreference: AmabAfabMedicalPreference.PREF_UNAVAILABLE_FOR_JOURNEY,
    workflow: MedicalQuestionsWorkflow.AFAB_MEDICAL_QUESTIONS
  },
  "6": {
    journey: "PRESERVATION",
    amabAfabPreference: AmabAfabMedicalPreference.AMAB,
    workflow: MedicalQuestionsWorkflow.AMAB_MEDICAL_QUESTIONS
  },
  "7": {
    journey: "LOW_TESTOSTERONE",
    amabAfabPreference: AmabAfabMedicalPreference.AMAB,
    workflow: MedicalQuestionsWorkflow.AMAB_MEDICAL_QUESTIONS
  },
  "8": {
    journey: "ASSISTED_REPRODUCTION",
    amabAfabPreference: AmabAfabMedicalPreference.AMAB,
    workflow: MedicalQuestionsWorkflow.AMAB_MEDICAL_QUESTIONS
  },
  "9": {
    journey: "LOW_TESTOSTERONE",
    amabAfabPreference: AmabAfabMedicalPreference.AFAB,
    workflow: MedicalQuestionsWorkflow.AFAB_MEDICAL_QUESTIONS
  },
  "10": {
    journey: "TRY_PREGNANT",
    amabAfabPreference: AmabAfabMedicalPreference.AMAB,
    workflow: MedicalQuestionsWorkflow.AMAB_MEDICAL_QUESTIONS
  },
  "11": {
    journey: "PREGNANT", // postpartum flow, but journey is PREGNANT
    amabAfabPreference: AmabAfabMedicalPreference.PREF_UNAVAILABLE_FOR_JOURNEY,
    workflow: MedicalQuestionsWorkflow.POSTPARTUM_MEDICAL_QUESTIONS
  }
}

const getMedicalFlowDetails = (journeyParam: string | undefined): MedicalFlowDetail | undefined => {
  if (journeyParam == null || journeyParam === "") {
    return undefined
  }
  return JourneyByUrlParam[journeyParam]
}

export const getWorkflowFromParam = (
  journeyParam: string | undefined,
  pregnancyAndPostpartumUpdatedRouting: boolean
): MedicalQuestionsWorkflow | undefined => {
  const details = getMedicalFlowDetails(journeyParam)
  // TODO - These can be removed when cleaning up LD flag
  if (journeyParam === "1" && !pregnancyAndPostpartumUpdatedRouting) {
    return MedicalQuestionsWorkflow.AFAB_MEDICAL_QUESTIONS
  }
  if (journeyParam === "11" && !pregnancyAndPostpartumUpdatedRouting) {
    return undefined
  }
  return details?.workflow
}

export const getAmabAfabMedicalPreferenceFromParam = (
  journeyParam: string | undefined
): AmabAfabMedicalPreference | undefined => {
  return getMedicalFlowDetails(journeyParam)?.amabAfabPreference
}

export const getJourneyFromParam = (journeyParam: string | undefined): string | undefined => {
  return getMedicalFlowDetails(journeyParam)?.journey
}

export const useMedicalQuestionMenuItemWorkflow = (): MedicalQuestionsWorkflow | undefined => {
  const { pregnancyAndPostpartumUpdatedRouting } = useFlags()
  const { journey: journeyParam } = useParams<{ journey: string }>()

  return getWorkflowFromParam(journeyParam, pregnancyAndPostpartumUpdatedRouting)
}
